import moment from 'moment';

export default {
    name: 'your-profile',
    props: {
        userData: Object,
        yourProfile: Object,
        genders: Array,
        countries: Array,
        loadUserData: Function
    },
    data() {
        return {

            message: null,
            messageClass: null,
            messageTimer: null,

            //Rules
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 50) || 'Name must be less than 50 characters'
            ]
        }
    },
    updated() {
        this.$refs.myProfileForm.resetValidation();
    },
    methods: {
        updateUserData() {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    FirstName: self.yourProfile.firstName,
                    LastName: self.yourProfile.lastName,
                    PostalCode: self.yourProfile.postalCode,
                    CountryId: self.yourProfile.countryId,
                    GenderId: self.yourProfile.genderId,
                    DateOfBirth: self.yourProfile.dateOfBirth,
                };

            if (!self.$refs.myProfileForm.validate()) {
                return;
            }

            self.$state.set("loading", true);

            self.$api.saveUser(self.userData, data, function (response) {
                let message = response.status != 200 &&
                    response.data ?
                    response.data.value : null;
                self.$state.set("loading", false);
                self.showMessage(message || 'Updating User Data failed.', 'error-message');
            }).then(function (responseData) {
                if (responseData) {
                    self.$state.set("loading", false);
                    self.loadUserData();
                }
            });
        },

        customFilter(item, queryText) {
            const textOne = (item.name || '').toLowerCase()
            const textTwo = (item.code || '').toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1
        },

        changePassword() {
            this.$authManager.changePassword();
        },

        showMessage(message, messageClass) {
            let self = this;

            self.message = message;
            self.messageClass = messageClass;

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.clearMessage(messageClass);
            }, 3000);
        },

        clearMessage(messageClass) {
            let self = this;

            self.messageClass = messageClass + ' fade-out';

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.message = null;
                self.messageClass = null;
            }, 700);

        }
    }
}
